import { useCallback, useMemo } from 'react'

import { ArrowUpDownIcon } from 'lucide-react'
import { ComboboxMulti } from 'twyne-new.ui'

import {
  SORT_DIRECTIONS,
  formatSortbyEntries,
  getSortFieldOptions,
  parseSortbyEntries,
} from '../utils/constants'

import ConfigField, { CONFIG_CONTROL_CLASS } from './ConfigField'

export default function SortEditor({ groupby = [], metrics = [], collection, sortby = [], onChange }) {
  const fieldOptions = useMemo(
    () => getSortFieldOptions(groupby, metrics, collection),
    [groupby, metrics, collection],
  )

  const options = useMemo(
    () => fieldOptions.flatMap(field => SORT_DIRECTIONS.map(direction => ({
      value: `${field.value} ${direction.value}`,
      label: `${field.label} · ${direction.label}`,
    }))),
    [fieldOptions],
  )

  const value = useMemo(
    () => formatSortbyEntries(parseSortbyEntries(sortby)),
    [sortby],
  )

  const handleChange = useCallback(nextValues => {
    const byField = new Map()
    parseSortbyEntries(nextValues).forEach(entry => byField.set(entry.field, entry))

    onChange(formatSortbyEntries([...byField.values()]))
  }, [onChange])

  return (
    <ConfigField label="Sort" icon={ArrowUpDownIcon}>
      <ComboboxMulti
        className={CONFIG_CONTROL_CLASS}
        options={options}
        value={value}
        onChange={handleChange}
        placeholder="Select sort"
        hideSelectAll
        maxCount={1}
        disabled={!options.length}
      />
    </ConfigField>
  )
}
